
import Fly from 'flyio/dist/npm/fly'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import LandingPageHeader from '@/components/LandingPageHeader'
import LandingPageFooter from '@/components/LandingPageFooter'
import LandingPageFooterDouble from '@/components/LandingPageFooterDouble'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
import {addToCart} from '@/api/resource'

export default {
components: {
XButton,
Box,
Flexbox,
FlexboxItem,
LandingPageHeader,
LandingPageFooter,
LandingPageFooterDouble,
IndexSidebar,
IndexFooter,
XInput,
Group,
Toast,
Swiper,
SwiperItem
},
data () {
return {
scrollTop: 0,
tabIndex: 0,
tabIndex1: 0,
currentIndex: 0,
liveData1: [],
liveData2: [],
liveData3: [],
videoData1: [],
videoData2: [],
videoData3: [],
weiboData1: [],
woaData1: [],
xhsData1: [],
xhsData2: [],
xhsData3: []
}
},
filters: {
originalPrice: function (value) {
const num = parseInt(value)
const num2 = num * 2
return num2
},
formatNumInTenThousand: function (data) {
const num = parseInt(data)
const num2 = num / 10000
if (num2 >= 1) {
return Math.round(num2 * 100) / 100 + '万'
} else {
return num
}
}
},
methods: {

changeKingTab (index) {
this.tabIndex1 = index
},

changeTab (index) {
this.tabIndex = index
},

handleDoubleData () {
let fly = new Fly() 

fly.request('https://www.xinmeibao.com//api/wap_12', {}, {
method: 'get'
}).then(resp => {
var transferData = JSON.parse(resp.data)
if (transferData.success) {
var doubleData = transferData.message
var liveData = doubleData.live
this.liveData1 = liveData.slice(0, 3)
this.liveData2 = liveData.slice(3, 6)
this.liveData3 = liveData.slice(6, 9)
var xhsData = doubleData.xhs
this.xhsData1 = xhsData.slice(0, 3)
this.xhsData2 = xhsData.slice(3, 6)
this.xhsData3 = xhsData.slice(6, 9)
var videoData = doubleData.video
this.videoData1 = videoData.slice(0, 3)
this.videoData2 = videoData.slice(3, 6)
this.videoData3 = videoData.slice(6, 9)
var weiboData = doubleData.weibo
this.weiboData1 = weiboData.slice(0, 4)
var woaData = doubleData.woa
this.woaData1 = woaData.slice(0, 4)
}
}).catch((e) => console.log('error', e))
},
handleAddToCart (id, taxonomy, type, redirect) {
addToCart(id, taxonomy, type, redirect).then(resp => {
if (resp.status) {
console.log(resp, 258)
this.$vux.toast.show({
text: '成功加入购物车'
})
if (redirect) {
switch (taxonomy) {
case 'xhs' :
this.$router.push('/cart?tab=2')
break
case 'woa' :
this.$router.push('/cart?tab=0')
break
case 'weibo' :
this.$router.push('/cart?tab=4')
break
case 'video' :
this.$router.push('/cart?tab=1')
break
case 'live' :
this.$router.push('/cart?tab=3')
break
}
}
}
}).catch((e) => {
if (e.status === 401) {
this.$vux.toast.show({
text: e.message
})
this.$router.push('/login')
} else if (e.status === 422) {
this.$vux.toast.show({
text: e.message
})
}
})
}
},
mounted () {
this.handleDoubleData()
}
}



// WEBPACK FOOTER //
// ./src/pages/double12/index.vue